// extracted by mini-css-extract-plugin
export default {"container":"themeToggle_container__f-zse"};